import React from "react";
import { spacing } from "../../style";
import glamorous from "glamorous";

const Buttons = glamorous.div({
  ...spacing.PADDING_TOP_SM,
  ...spacing.PADDING_BOTTOM_SM,
  whiteSpace: "nowrap"
});

const Button = glamorous.div(
  {
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: "8px",
    ":last-child": {
      marginRight: 0
    }
  },
  ({ align }) => {
    return align ? { textAlign: align } : null;
  }
);

const ButtonSet = props => {
  // Wrap each element in a ButtonSet with a div to control the vertical alignment.
  let renderBtns = () => {
    let children = React.Children.map(props.children, function(child) {
      if (child !== null) {
        return <Button>{child}</Button>;
      }
    });
    return children;
  };

  return <Buttons {...props.styles}>{renderBtns()}</Buttons>;
};

ButtonSet.propTypes = {
  children: React.PropTypes.node.isRequired
};

export default ButtonSet;



// WEBPACK FOOTER //
// ./src/components/blocks/ButtonSet.jsx